export default remote => ({
    position    : () => remote.get('flight/airport/position'),
    destinations    : () => remote.get('flight/airport/destinations'),
    autocomplete: (term, data) => remote.get(`flight/airport/autocomplete/${ term }`, { params: data })
});
